/**
 * Shared formatting utilities for the power-up SDK
 */

/**
 * Formats a timestamp to show only the date (no time)
 * @param timestamp - ISO 8601 timestamp string
 * @returns Formatted date string (e.g., "1/1/2023")
 */
export const formatDate = (timestamp: string): string => {
  return new Date(timestamp).toLocaleDateString();
};

/**
 * Formats an ID to show only the first 6 characters with ellipsis for longer IDs
 * @param id - The ID string to format
 * @returns Formatted ID string (e.g., "550e84..." for UUIDs)
 */
export const formatId = (id: string): string => {
  if (id.length <= 6) {
    return id;
  }
  return `${id.substring(0, 6)}...`;
};
